(function($, Drupal) {
  'use strict';
  Drupal.behaviors.courses_readmore = {
    attach: function(context, settings) {
      $('.read-more-btn', context).once('courses_readmore').on('click', function() {
        let $button = $(this);
        $button.parent().toggleClass('expanded');
      });

      $('.js-copy-link', context).once('copy_link').on('click', function() {
        let $button = $(this);
        var inp = document.createElement('input');
        document.body.appendChild(inp);
        inp.value = $(this).find('.visually-hidden').first().text();
        inp.select();
        document.execCommand('copy', false);
        inp.remove();
        $button.find('.tooltip').fadeIn(200);
        setTimeout(function() {
          $button.find('.tooltip').fadeOut(200);
        }, 1000);
      });

      $('#toggle-filters').once('toggle-filters').on('click touch', function() {
        $(this).toggleClass('expanded');

        if ($(this).hasClass('expanded')) {
          $(this).next('.hidden-filters-wrap').slideDown(300);
        }
        else {
          $(this).next('.hidden-filters-wrap').slideUp(300);
        }
      });

      if ($('.block-inline-blocksign-up').length) {
        $('#edit-submit--2').text('Sign In');
      }
    }
  };
})(jQuery, Drupal);
